import { autenticado } from "shared/helpers/auth-functions";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router";
import { UserStatus } from "shared/enums/UserStatus";
import AlternativeAutentication from "./AlternativeAutentication";

interface RouteProps {
  autenticacaoNecessaria?: boolean;
  claimNecessaria?: string;
  component: any;
  layout: React.FC;
  path?: string;
  statusNecessario?: UserStatus[];
  [x: string]: any;
}

const RotaCustomizada: React.FC<RouteProps> = (props) => {
  const {
    autenticacaoNecessaria = true,
    children,
    component: Component,
    layout: Layout,
    path,
    statusNecessario,
    ...rest
  } = props;
  const { loggedUser, loading } = useSelector((state: any) => state.users);

  const urlSearch = new URLSearchParams(props.location.search);
  const hasStatusNeeded = (status: UserStatus) => {
    return !statusNecessario || statusNecessario?.includes(status);
  };

  if (urlSearch.has("token") && path?.includes("/diagnostico-carreira")) {
    localStorage.setItem("token", urlSearch.get("token") || "");
  }

  const diagnosticAccessByArtist = () =>
    path?.includes("/diagnostico-carreira") && urlSearch.has("token");

  if (urlSearch.has("code") && !urlSearch.has("state")) {
    return <AlternativeAutentication {...props} />;
  }

  const saveReturnURLAndRedirectLogin = () => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/"
    )
      sessionStorage.setItem("returnURL", window.location.pathname);
    return <Redirect to="/login" />;
  };
  if (
    ((autenticacaoNecessaria && !autenticado()) ||
      loggedUser?.deviceStatus === 3) &&
    path !== "/login"
  ) {
    return saveReturnURLAndRedirectLogin();
  }

  if (
    autenticacaoNecessaria &&
    loggedUser?.deviceStatus === 0 &&
    !loading &&
    !diagnosticAccessByArtist()
  ) {
    return saveReturnURLAndRedirectLogin();
  }

  const statusGuard = hasStatusNeeded(loggedUser.status);

  if (loading && autenticacaoNecessaria)
    return <div style={{ height: "100vh", backgroundColor: "#26272c" }} />;

  if (loggedUser.status === UserStatus.CommercialDone && path !== "/team-start")
    return <Redirect to="/team-start" />;

  if (
    loggedUser.status === UserStatus.TeamDisabled &&
    !path?.includes("/team-issue") &&
    !path?.includes("/diagnostico-carreira")
  )
    return <Redirect to="/team-issue" />;

  if (!loading && !statusGuard) return <Redirect to="/radar" />;

  return (
    <Route
      {...rest}
      render={(routeProps) => (
        // <I18nLayout>
        <Layout>
          <Component {...routeProps} />
        </Layout>
        // </I18nLayout>
      )}
    />
  );
};

export default RotaCustomizada;
